
export class CouponPaymentDetail {

    refNo: number;
    couponCode: string;
    amount: number;
    coupon: any;
    couponPaymentCode: string;
}
